import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f616c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "debit-payment-confirmation content position-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-1" }, "Direct debit and terms and conditions acceptance", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "item-body pb-3" }, "Please enter the insured's date of birth to verify their identity.", -1))
const _hoisted_4 = { class: "pb-2" }
const _hoisted_5 = { class: "pb-10" }
const _hoisted_6 = { class: "row overflow-x-hidden" }
const _hoisted_7 = { class: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-end center-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TextInputSmall = _resolveComponent("TextInputSmall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DatePicker, {
        value: _ctx.dateOfBirth,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
        title: _ctx.title,
        "validation-error": _ctx.readError('dateOfBirth'),
        "is-mobile-screen": _ctx.isMobileScreen,
        class: "px-0 mb-4 me-2"
      }, null, 8, ["value", "title", "validation-error", "is-mobile-screen"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_TextInputSmall, {
        value: _ctx.verificationCode,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.verificationCode) = $event)),
        title: 'Policy ID',
        "validation-error": _ctx.readError('policyid'),
        "is-mobile-screen": _ctx.isMobileScreen,
        class: "px-0 mb-4 me-2"
      }, null, 8, ["value", "validation-error", "is-mobile-screen"])
    ]),
    _createElementVNode("hr", {
      class: _normalizeClass(["hr medium-bottom-spacing", _ctx.isMobileScreen ? 'd-none': ''])
    }, null, 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-booster-primary float-end",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextPage()))
        }, "Next")
      ])
    ])
  ]))
}